import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { Location } from 'react-router-dom'
import { isClientLibrariesTrial } from '@disco/state-management/selectors/user'
import BrowseLibraries from './BrowseLibraries'

const BrowseLibrariesContainer = ({
  location,
  children,
}: {
  location: Location
  children: React.ReactNode
}): React.ReactNode => {
  const clientLibrariesTrial: boolean = useSelector(isClientLibrariesTrial)
  return (
    <BrowseLibraries
      clientLibrariesTrial={clientLibrariesTrial}
      location={location}
      showInBrowseLibrariesPage
    >
      {children}
    </BrowseLibraries>
  )
}

export default BrowseLibrariesContainer
